<div class="modal">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Detalji za rok</h3>
    </div>
    <div class="card-body">
      <div>
        <div>Rok: {{ orderDay.date | date: 'dd/MM/yy' }}</div>
        <div>Komada: {{ orderDay.quantity }}</div>
      </div>
      <hr>
      <div>Komentar: {{ orderDay.comment }}</div>
    </div>
    <div class="card-footer text-end">
      <button class="btn btn-secondary btn-question" (click)="emitFalse()">U redu</button>
    </div>
  </div>
</div>
